module.exports = __webpack_public_path__ + "static/media/default_nearme.c51b80fe.svg";